module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-root-1.76d52aa5.svg";